import React, { PropsWithChildren } from 'react';
import * as authentication from '~/util/authentication';

/**
 * Clear out the user's authentication token and refresh the page
 *
 * @param url url to redirect to after logout, if not provided, the page will be reloaded.
 */

export function logout( url?: string ) {
  authentication.clearToken();
  if ( url ) {
    window.location.href = url;
  } else {
    window.location.reload();
  }
}

/**
 * Persist the user's authentication token and then refresh the page.
 *
 * @param token authentication token to use for this user.
 * @param url url to redirect to after login. If not provided, the page will be reloaded.
 */

export function login( token: string, url?: string ) {
  authentication.setToken( token );
  if ( url ) {
    window.location.href = url;
  } else {
    window.location.reload();
  }
}

type BouncerProps = PropsWithChildren<{
  LoginView: React.FC;
}>;

/**
 * This component checks if the current user is logged in. If not, it will display
 * the `LoginView`. If the user is logged in, it will display its children.
 **/

const Bouncer = ( props: BouncerProps ) => {
  const { LoginView, children } = props;

  const token = authentication.getToken();

  if ( !token ) {
    return <LoginView />;
  } else {
    return <>{ children }</>;
  }
};

export { Bouncer };
